import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
}
const SEO = ({
  title,
  description,
  canonicalUrl,
  keywords = 'SmartSoda, office beverages, sustainable drinks, premium beverages, beverage dispenser',
  ogImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/398zF3f9vnPCBcDJKMBLw8/HeroSmartSoda.png',
  ogType = 'website',
  twitterCard = 'summary_large_image'
}: SEOProps) => {
  // Ensure title is not too long (Google typically displays first 50-60 characters)
  const metaTitle = title.length > 60 ? `${title.substring(0, 57)}...` : title;
  // Ensure description is not too long (Google typically displays ~155-160 characters)
  const metaDescription = description.length > 160 ? `${description.substring(0, 157)}...` : description;
  return <Helmet data-id="element-649">
      {/* Basic Meta Tags */}
      <title data-id="element-650">{metaTitle}</title>
      <meta name="description" content={metaDescription} data-id="element-651" />
      <meta name="keywords" content={keywords} data-id="element-652" />
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} data-id="element-653" />}
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-654" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} data-id="element-655" />}
      <meta property="og:title" content={metaTitle} data-id="element-656" />
      <meta property="og:description" content={metaDescription} data-id="element-657" />
      <meta property="og:image" content={ogImage} data-id="element-658" />
      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} data-id="element-659" />
      <meta name="twitter:title" content={metaTitle} data-id="element-660" />
      <meta name="twitter:description" content={metaDescription} data-id="element-661" />
      <meta name="twitter:image" content={ogImage} data-id="element-662" />
      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-id="element-663" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" data-id="element-664" />
      <meta name="robots" content="index, follow" data-id="element-665" />
    </Helmet>;
};
export default SEO;